<template>
  <VModal :showing="showing" @update:showing="goToDeckList">
    <div class="w-screen max-w-md">
      <h2 class="text-lg mb-0">This deck is currently being duplicated</h2>
      <p class="my-6 text-gray-600">Please check back later.</p>
      <VButton class="w-full" variant="dark" size="sm" data-testid="back-button" @click="goToDeckList">Back to Editor</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['update:showing'])

const { vpeUrl } = useVpeUrl()

function goToDeckList() {
  window.location.href = `${vpeUrl}/decks`
}
</script>
